(() => {
  const body = document.body;
  const stringsNode = document.getElementById('StudioText');
  if (!stringsNode) return;
  const text = JSON.parse(stringsNode.textContent);
  const root = (body.dataset.storeRoot || '/').replace(/\/?$/, '/');
  const cartDialog = document.getElementById('StudioCart');
  const menuDialog = document.getElementById('StudioMenu');
  const zoomDialog = document.getElementById('StudioZoom');
  const itemsNode = document.querySelector('[data-cart-items]');
  const errorNode = document.querySelector('[data-cart-error]');
  const footerNode = document.querySelector('[data-cart-footer]');
  const totalNode = document.querySelector('[data-cart-total]');
  const statusNode = document.querySelector('[data-store-status]');
  let currency = body.dataset.currency || 'EUR';
  let cartOpener = null;
  let menuOpener = null;
  let zoomOpener = null;
  let busy = false;
  const money = value => new Intl.NumberFormat(body.dataset.locale || 'lt-LT', {style:'currency',currency}).format(value / 100);
  const node = (tag, className, content) => {
    const el = document.createElement(tag);
    if (className) el.className = className;
    if (content !== undefined) el.textContent = content;
    return el;
  };
  const announce = message => { statusNode.textContent = message; };
  const setError = message => { errorNode.textContent = message || ''; errorNode.hidden = !message; };
  async function request(path, options) {
    const response = await fetch(root + path, {credentials:'same-origin', ...options});
    const result = await response.json();
    if (!response.ok) { const failure = new Error(result.description || result.message || text.cartError); failure.storeMessage = true; throw failure; }
    return result;
  }
  let giftDirty = false;
  let giftVersion = 0;
  let giftPending = Promise.resolve();
  let giftSnapshot = null;
  function syncGift(cart) {
    if (giftDirty) return;
    const attributes = cart.attributes || {};
    document.querySelectorAll('[data-gift-options]').forEach(root => {
      const toggle = root.querySelector('[data-gift-toggle]');
      const message = root.querySelector('[data-gift-message]');
      const wrap = root.querySelector('.cart-gift__message');
      const enabled = attributes['Gift order'] === 'Yes';
      if (toggle) toggle.checked = enabled;
      if (message) message.value = attributes['Gift message'] || '';
      if (wrap) wrap.hidden = !enabled;
    });
  }
  function renderCart(cart) {
    currency = cart.currency || currency;
    syncGift(cart);
    document.querySelectorAll('[data-cart-count]').forEach(el => { el.textContent = cart.item_count; });
    totalNode.textContent = money(cart.total_price);
    footerNode.hidden = cart.item_count === 0;
    itemsNode.replaceChildren();
    if (!cart.item_count) {
      const empty = node('div', 'cart-empty');
      empty.append(node('p', '', text.empty));
      const link = node('a', 'button', text.choose);
      link.href = text.collectionUrl;
      empty.append(link);
      itemsNode.append(empty);
      return;
    }
    cart.items.forEach(item => {
      const line = node('div', 'cart-line');
      line.dataset.key = item.key;
      const imageLink = node('a', 'cart-line__photo');
      imageLink.href = item.url;
      if (item.image) {
        const image = node('img');
        image.src = item.image;
        image.alt = item.product_title;
        image.width = 88;
        image.height = 88;
        imageLink.append(image);
      }
      const copy = node('div', 'cart-line__copy');
      const heading = node('h3');
      const titleLink = node('a', '', item.product_title);
      titleLink.href = item.url;
      heading.append(titleLink);
      copy.append(heading);
      if (item.variant_title && item.variant_title !== 'Default Title') copy.append(node('p', 'cart-line__color', item.variant_title));
      copy.append(node('p', 'cart-line__price', money(item.final_line_price)));
      const controls = node('div', 'cart-line__controls');
      const quantity = node('div', 'cart-line__quantity');
      for (const delta of [-1, 1]) {
        const button = node('button', '', delta === -1 ? '−' : '+');
        button.type = 'button';
        button.dataset.cartQuantity = Math.max(0, item.quantity + delta);
        button.dataset.action = delta === -1 ? 'minus' : 'plus';
        button.setAttribute('aria-label', (delta === -1 ? text.decrease : text.increase) + ' · ' + item.product_title);
        if (delta === 1) quantity.append(node('span', '', String(item.quantity)));
        quantity.append(button);
      }
      const remove = node('button', 'cart-remove', text.remove);
      remove.type = 'button';
      remove.dataset.cartQuantity = '0';
      remove.dataset.action = 'remove';
      remove.setAttribute('aria-label', text.remove + ' · ' + item.product_title);
      controls.append(quantity, remove);
      copy.append(controls);
      line.append(imageLink, copy);
      itemsNode.append(line);
    });
  }
  async function openCart(trigger) {
    if (menuDialog.open) menuDialog.close();
    cartOpener = trigger;
    setError('');
    itemsNode.replaceChildren(node('p', 'small-text', text.loading));
    footerNode.hidden = true;
    if (!cartDialog.open) cartDialog.showModal();
    try { renderCart(await request('cart.js')); }
    catch (error) {
      setError(text.cartError);
      const link = node('a', 'text-link', text.viewCart);
      link.href = root + 'cart';
      itemsNode.replaceChildren(link);
    }
  }
  cartDialog.addEventListener('close', () => { if (cartOpener?.isConnected && !cartOpener.disabled) cartOpener.focus({preventScroll:true}); });
  menuDialog.addEventListener('close', () => {
    document.querySelectorAll('[data-open-menu]').forEach(el => el.setAttribute('aria-expanded','false'));
    if (menuOpener?.isConnected) menuOpener.focus({preventScroll:true});
  });
  zoomDialog.addEventListener('close', () => { if (zoomOpener?.isConnected) zoomOpener.focus({preventScroll:true}); });
  [cartDialog, menuDialog, zoomDialog].forEach(dialog => {
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    });
  });
  function selectPhoto(button) {
    const gallery = button.closest('[data-gallery]');
    const main = gallery.querySelector('.gallery-main');
    const image = main.querySelector('img');
    gallery.querySelectorAll('[data-gallery-thumb]').forEach(el => el.setAttribute('aria-pressed', String(el === button)));
    image.src = button.dataset.src;
    if (button.dataset.srcset) image.srcset = button.dataset.srcset;
    else image.removeAttribute('srcset');
    image.alt = button.dataset.alt;
    main.href = button.dataset.zoom;
  }
  document.addEventListener('click', async event => {
    const target = event.target.closest('a,button');
    if (!target) return;
    if (target.hasAttribute('data-open-cart')) { event.preventDefault(); await openCart(target); }
    else if (target.hasAttribute('data-close-cart')) cartDialog.close();
    else if (target.hasAttribute('data-open-menu')) {
      menuOpener = target;
      target.setAttribute('aria-expanded','true');
      menuDialog.showModal();
    } else if (target.hasAttribute('data-close-menu') || target.closest('#StudioMenu nav')) menuDialog.close();
    else if (target.hasAttribute('data-close-zoom')) zoomDialog.close();
    else if (target.hasAttribute('data-open-zoom')) {
      event.preventDefault();
      zoomOpener = target;
      const image = zoomDialog.querySelector('[data-zoom-image]');
      image.src = target.href;
      image.alt = target.querySelector('img').alt;
      zoomDialog.showModal();
    } else if (target.hasAttribute('data-gallery-thumb')) {
      selectPhoto(target);
      const imageId = target.dataset.imageId;
      if (imageId) {
        const radio = Array.from(document.querySelectorAll('[data-variant-radio]')).find(input => input.dataset.imageId === imageId);
        if (radio && !radio.checked) {
          radio.checked = true;
          radio.dispatchEvent(new Event('change', {bubbles:true}));
        }
      }
    }
    else if (target.hasAttribute('data-quantity-step')) {
      const input = target.closest('.quantity-control').querySelector('input');
      const minimum = Number(input.min || 0);
      const maximum = input.max ? Number(input.max) : Infinity;
      input.value = Math.min(maximum, Math.max(minimum, (Number(input.value) || minimum) + Number(target.dataset.quantityStep)));
      input.dispatchEvent(new Event('change', {bubbles:true}));
    } else if (target.hasAttribute('data-cart-quantity')) {
      if (busy) return;
      busy = true;
      setError('');
      const line = target.closest('.cart-line');
      const key = line.dataset.key;
      const action = target.dataset.action;
      const quantity = Number(target.dataset.cartQuantity);
      itemsNode.querySelectorAll('button').forEach(el => { el.disabled = true; });
      footerNode.querySelector('button').disabled = true;
      try {
        const cart = await request('cart/change.js', {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:key,quantity})});
        renderCart(cart);
        announce(text.cart + ' ' + cart.item_count);
        const updatedLine = Array.from(itemsNode.querySelectorAll('.cart-line')).find(el => el.dataset.key === key);
        const focusTarget = updatedLine?.querySelector('[data-action="' + action + '"]') || itemsNode.querySelector('button,a') || cartDialog.querySelector('[data-close-cart]');
        focusTarget.focus({preventScroll:true});
      } catch (error) { setError(error.storeMessage ? error.message : text.cartError); }
      finally { busy = false; itemsNode.querySelectorAll('button').forEach(el => { el.disabled = false; }); footerNode.querySelector('button').disabled = false; }
    }
  });
  document.addEventListener('submit', async event => {
    const form = event.target;
    if (!form.matches('.product-form,.quick-form')) return;
    event.preventDefault();
    if (busy) return;
    busy = true;
    const button = event.submitter || form.querySelector('[type=submit]');
    const original = button.innerHTML;
    const error = form.querySelector('.form-error');
    const allButtons = Array.from(document.querySelectorAll('.product-form [type=submit],.quick-form [type=submit],[data-mobile-buy]'));
    const states = allButtons.map(el => [el,el.disabled]);
    states.forEach(([el]) => { el.disabled = true; });
    button.textContent = text.adding;
    button.setAttribute('aria-busy','true');
    error.hidden = true;
    try {
      await request('cart/add.js', {method:'POST',body:new FormData(form)});
      announce(text.added);
      await openCart(button);
    } catch (failure) {
      error.textContent = failure.storeMessage ? failure.message : text.addError;
      error.hidden = false;
      error.classList.remove('sr-only');
      announce(error.textContent);
    } finally {
      button.innerHTML = original;
      button.removeAttribute('aria-busy');
      states.forEach(([el,wasDisabled]) => { el.disabled = wasDisabled; });
      busy = false;
    }
  });
  document.addEventListener('change', event => {
    const input = event.target;
    if (input.matches('[data-light-option]')) {
      const image = input.closest('.light-section').querySelector('[data-light-photo]');
      image.src = input.dataset.src;
      image.removeAttribute('srcset');
      image.alt = input.dataset.alt;
    }
    if (input.matches('[data-variant-radio]')) {
      const info = input.closest('.product-information');
      const form = input.closest('form');
      const hidden = form?.querySelector('[data-variant-id]');
      if (hidden) hidden.value = input.value;
      info.querySelector('[data-product-price]').textContent = input.dataset.price;
      const current = info.querySelector('[data-current-colour]');
      if (current) current.textContent = input.dataset.label;
      const available = input.dataset.available === 'true';
      const button = info.querySelector('[data-buy-button]');
      if (button) {
        button.disabled = !available;
        const label = button.querySelector('[data-buy-label]');
        if (label) label.textContent = available ? text.add : text.soldOut;
      }
      const gallery = document.querySelector('[data-gallery]');
      const main = gallery?.querySelector('.gallery-main');
      const image = main?.querySelector('img');
      const matchingThumb = input.dataset.imageId
        ? Array.from(gallery?.querySelectorAll('[data-gallery-thumb]') || []).find(thumb => thumb.dataset.imageId === input.dataset.imageId)
        : null;
      if (matchingThumb) {
        selectPhoto(matchingThumb);
      } else {
        if (image && input.dataset.image) {
          image.src = input.dataset.image;
          image.removeAttribute('srcset');
          image.alt = text.productTitle ? text.productTitle + ' · ' + input.dataset.label : input.dataset.label;
        }
        if (main && input.dataset.zoom) main.href = input.dataset.zoom;
        gallery?.querySelectorAll('[data-gallery-thumb]').forEach(thumb => thumb.setAttribute('aria-pressed', 'false'));
      }
  const bar = document.querySelector('[data-mobile-bar]');
      if (bar) {
        const price = bar.querySelector('[data-mobile-price]'); if (price) price.textContent = input.dataset.price;
        const label = bar.querySelector('[data-mobile-label]'); if (label) label.textContent = input.dataset.label;
        const mobileButton = bar.querySelector('button'); if (mobileButton) mobileButton.disabled = !available;
      }
      const url = new URL(location.href); url.searchParams.set('variant', input.value); history.replaceState({},'',url);
    }
  });
  function captureGift(root) {
    const enabled = root.querySelector('[data-gift-toggle]').checked;
    giftSnapshot = {'Gift order': enabled ? 'Yes' : '', 'Gift message': enabled ? root.querySelector('[data-gift-message]').value : ''};
    giftDirty = true;
    const version = ++giftVersion;
    document.querySelectorAll('[data-gift-options]').forEach(other => {
      other.querySelector('[data-gift-toggle]').checked = enabled;
      other.querySelector('[data-gift-message]').value = giftSnapshot['Gift message'];
      other.querySelector('.cart-gift__message').hidden = !enabled;
    });
    const snapshot = {...giftSnapshot};
    giftPending = giftPending.catch(() => {}).then(async () => {
      await request('cart/update.js', {method:'POST',keepalive:true,headers:{'Content-Type':'application/json'},body:JSON.stringify({attributes:snapshot})});
      if (version === giftVersion) {
        giftDirty = false;
        document.querySelectorAll('[data-gift-error]').forEach(el => { el.hidden = true; });
        announce(text.giftSaved);
      }
    });
    giftPending.catch(() => {
      document.querySelectorAll('[data-gift-error]').forEach(el => { el.textContent = text.giftError; el.hidden = false; });
      announce(text.giftError);
    });
  }
  document.addEventListener('change', event => {
    if (event.target.matches('[data-gift-toggle]')) captureGift(event.target.closest('[data-gift-options]'));
  });
  document.addEventListener('input', event => {
    if (event.target.matches('[data-gift-message]')) captureGift(event.target.closest('[data-gift-options]'));
  });
  document.addEventListener('submit', async event => {
    const form = event.target;
    if (form.matches('.language-switch')) {
      form.querySelector('[name="return_to"]').value = location.pathname + location.search + location.hash;
    }
    if (form.dataset.giftReady === 'true' || !giftDirty || form.matches('.product-form,.quick-form')) return;
    event.preventDefault();
    const submitter = event.submitter;
    try {
      await giftPending;
      if (giftDirty) return;
      form.dataset.giftReady = 'true';
      form.requestSubmit(submitter);
    } catch (_) {}
  });
  document.addEventListener('click', async event => {
    const link = event.target.closest('a[href]');
    if (!giftDirty || !link || event.defaultPrevented || event.ctrlKey || event.metaKey || link.target === '_blank' || link.getAttribute('href').startsWith('#')) return;
    event.preventDefault();
    try { await giftPending; if (!giftDirty) location.assign(link.href); } catch (_) {}
  });

  document.addEventListener('keydown', event => {
    const target = event.target;
    if (!target.matches('[data-gallery-thumb]')) return;
    const buttons = Array.from(target.closest('.gallery-thumbnails').querySelectorAll('button'));
    const index = buttons.indexOf(target);
    let next = index;
    if (event.key === 'ArrowRight') next = (index + 1) % buttons.length;
    else if (event.key === 'ArrowLeft') next = (index - 1 + buttons.length) % buttons.length;
    else if (event.key === 'Home') next = 0;
    else if (event.key === 'End') next = buttons.length - 1;
    else return;
    event.preventDefault();
    buttons[next].focus();
    selectPhoto(buttons[next]);
  });
  const mobileHeaderQuery = window.matchMedia('(max-width: 599px)');
    let lastHeaderScrollY = window.scrollY;
    let headerFramePending = false;
  
    function updateMobileHeader() {
      const y = window.scrollY;
      const html = document.documentElement;
  
      if (!mobileHeaderQuery.matches) {
  html.classList.remove('mobile-header-floating','mobile-header-visible','mobile-header-compact');
  lastHeaderScrollY = y;
  return;
      }
  
      const floating = y > 110;
      html.classList.toggle('mobile-header-floating', floating);
  
      if (!floating) {
  html.classList.remove('mobile-header-visible','mobile-header-compact');
      } else {
  const delta = y - lastHeaderScrollY;
  if (delta < -4) html.classList.add('mobile-header-visible');
  else if (delta > 4) html.classList.remove('mobile-header-visible');
  html.classList.add('mobile-header-compact');
      }
  
      lastHeaderScrollY = y;
    }
  
    function requestMobileHeaderUpdate() {
      if (headerFramePending) return;
      headerFramePending = true;
      requestAnimationFrame(() => {
  updateMobileHeader();
  headerFramePending = false;
      });
    }
  
    updateMobileHeader();
    window.addEventListener('scroll', requestMobileHeaderUpdate, {passive:true});
    window.addEventListener('resize', requestMobileHeaderUpdate);
  const bar = document.querySelector('[data-mobile-bar]');
  const primary = document.querySelector('.product-form [data-buy-button]');
  if (bar && primary && 'IntersectionObserver' in window) {
    new IntersectionObserver(entries => {
      const entry = entries[0];
      bar.hidden = entry.isIntersecting || entry.boundingClientRect.top > 0;
    }).observe(primary);
  }
})();

